import { render, staticRenderFns } from "./premiumEditor.vue?vue&type=template&id=06e7e6ae&scoped=true"
import script from "./premiumEditor.vue?vue&type=script&lang=js"
export * from "./premiumEditor.vue?vue&type=script&lang=js"
import style0 from "./premiumEditor.vue?vue&type=style&index=0&id=06e7e6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7e6ae",
  null
  
)

export default component.exports